import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';
import { Socket } from 'ngx-socket-io';

@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.scss'],
})
export class DriverComponent implements OnInit {
  url: string = 'users';
  data: Array<any> = [];
  totalConductores = 0;
  totalActivos = 0;
  totalInactivos = 0;
  ultimoRegistro = '-';
  totalNumber = 0;
  byCities = 0;
  active = 0;
  busy = 0;
  pending = 0;
  sanctioned = 0;
  filter = 2;
  step = 0;
  resumenCards = [
    {
      //label: 'TN',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Total',
    },
    {
      //label: 'BC',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      desc: 'Cities',
    },
    {
      //label: 'A',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'Active',
    },
    {
      //label: 'B',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Busy',
    },
    {
      //label: 'P',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Pending',
    },
    {
      //label: 'S',
      value: 0,
      icon: 'fas fa-user-slash',
      bgClass: 'bg-white',
      desc: 'Sanctioned',
    },
  ];
  
  resumenCardsTwo = [
     {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Drivers',
      route: '/logistics',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Customers',
      route: '/logistics/customers',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Metrics',
      route: '/logistics/fees',
    },
  ];

  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private socket: Socket
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getStats() {
    this.totalConductores = this.data.length;
    this.totalActivos = this.data.filter((d) => d.status).length;
    this.totalInactivos = this.data.filter((d) => !d.status).length;
    this.ultimoRegistro = this.data.length
      ? this.data[this.data.length - 1].firstname +
        ' ' +
        this.data[this.data.length - 1].lastname
      : '-';
  }

  getResumenEstados() {
    this.totalNumber = this.data.length;

    //this.byCities = new Set(this.data.map((d) => d.city)).size;
    this.byCities = new Set(
      this.data.map((d) => d.city).filter((c) => c && c.trim() !== '')
    ).size;
    console.log('byCities', this.byCities);
    this.active = this.data.filter((d) => d.status === 'active').length;
    this.busy = this.data.filter((d) => d.status === 'busy').length;
    this.pending = this.data.filter((d) => d.status === 'pending').length;
    this.sanctioned = this.data.filter((d) => d.status === 'sanctioned').length;

    this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = this.byCities;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned;
  }

  filtrarConductores() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.firstname && item.firstname.toLowerCase().includes(texto)) ||
          (item.lastname && item.lastname.toLowerCase().includes(texto)) ||
          (item.phone && item.phone.toLowerCase().includes(texto)) ||
          (item.role &&
            item.role.name &&
            item.role.name.toLowerCase().includes(texto)) ||
          (item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          (item.state && item.state.toLowerCase().includes(texto)) ||
          (item.city && item.city.toLowerCase().includes(texto))
        );
      });
    }
    this.getStatsFiltrado();
    this.getResumenEstadosFiltrado();
  }

  getStatsFiltrado() {
    this.totalConductores = this.filteredData.length;
    this.totalActivos = this.filteredData.filter((d) => d.status).length;
    this.totalInactivos = this.filteredData.filter((d) => !d.status).length;
    this.ultimoRegistro = this.filteredData.length
      ? this.filteredData[this.filteredData.length - 1].firstname +
        ' ' +
        this.filteredData[this.filteredData.length - 1].lastname
      : '-';
    //this.byCities = new Set(this.filteredData.map((d) => d.city)).size;
    this.byCities = new Set(
      this.data.map((d) => d.city).filter((c) => c && c.trim() !== '')
    ).size;
  }

  getResumenEstadosFiltrado() {
    this.totalNumber = this.filteredData.length;
    this.active = this.filteredData.filter((d) => d.status === 'active').length;
    this.busy = this.filteredData.filter((d) => d.status === 'busy').length;
    this.pending = this.filteredData.filter(
      (d) => d.status === 'pending'
    ).length;
    this.sanctioned = this.filteredData.filter(
      (d) => d.status === 'sanctioned'
    ).length;

    this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = this.byCities;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned;
  }

  actualizarSugerencias() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.firstname) sugerenciasSet.add(item.firstname);
      if (item.lastname) sugerenciasSet.add(item.lastname);
      if (item.phone) sugerenciasSet.add(item.phone);
      if (item.role && item.role.name) sugerenciasSet.add(item.role.name);
      if (item.rol_user) sugerenciasSet.add(item.rol_user);
      if (item.state) sugerenciasSet.add(item.state);
      if (item.city) sugerenciasSet.add(item.city);
    });
    this.sugerenciasBusqueda = Array.from(sugerenciasSet).filter(Boolean);
  }

  getData(): void {
    this.dataService.getData(`${this.url}/drivers`).subscribe((response) => {
      //  this.dataService.getData(`${this.url}`).subscribe((response) => {
      ///drivers sin url
      console.log('response en driver', response);
      //if (response.rst) {
      if (response) {
        this.data = response.data;
        // Ordenar: true primero, luego false
        /* this.data.sort((a: any, b: any) => {
          return a.status === b.status ? 0 : a.status ? -1 : 1;
        }); */
        this.connectSocket();
        this.filteredData = [...this.data];
        this.getStats();
        this.getResumenEstados();
        this.actualizarSugerencias();
        this.filteredData = response.data.map((driver) => ({
          ...driver,
          online: false,
        }));

        this.filteredData.forEach((driver) => {
          this.socket.emit(
            'reqDriverStatus',
            driver.username,
            (isOnline: boolean) => {
              driver.online = isOnline;
            }
          );
        });
      } else {
        this.messageService.add(response.msg, 'secondary');
      }
    });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  drivers() {
    this.step = 0;
    this.filteredData = [...this.data];
    /* this.dataService
      .getData(`${this.url}/drivers/${this.filter}`)
      .subscribe((response) => {
        if (response.rst) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.getStats();
          this.getResumenEstados();
          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      }); */
  }

  runners() {
    this.step = 1;
    this.filteredData = this.data.filter((res) => !!res.runner);
    /* this.dataService
      .getData(`${this.url}/drivers/${this.filter}`)
      .subscribe((response) => {
        if (response.rst) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.getStats();
          this.getResumenEstados();
          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      }); */
  }

  handlers() {
    this.step = 2;
    this.filteredData = this.data.filter((res) => !!res.handler);
    /* this.dataService
      .getData(`${this.url}/drivers/${this.filter}`)
      .subscribe((response) => {
        if (response.rst) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.getStats();
          this.getResumenEstados();
          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      }); */
  }

  connectSocket() {
    //if (!this.socket.connected) {
    this.socket.connect();
    console.log('conectado a sockets');
    //}
  }

  disconnectSocket() {
    this.socket.disconnect();
    console.log('desconectado sockets');
  }
}
